export default __webpack_public_path__ + "netflix-na-vivo-tv.svg";